// glowing border color for communication center
export function ruleDisplayBorderColor(displayColor: string): object {
	
	// Create a semi-transparent version of the display color for the shadow effect
	const hexToRgba = (hex, alpha = 1) => {
		const r = parseInt(hex.slice(1, 3), 16);
		const g = parseInt(hex.slice(3, 5), 16);
		const b = parseInt(hex.slice(5, 7), 16);
		return `rgba(${r}, ${g}, ${b}, ${alpha})`;
	};
	
	const transparentColor = hexToRgba(displayColor, 0.3);
	
	return {
		borderColor: displayColor,
		'--pulse-color': displayColor, // fully saturated border color
		'--pulse-color-transparent': transparentColor // pulsing transparent shadow color
	};
}

// volie toolbar background color pulse
export function ruleDisplayToolbarColor(displayColor: string): object {
	
	// Create a whitened version of the color for the alternating effect
	const hexToWhitened = (hex) => {

		// parse initial color
		const r = parseInt(hex.slice(1, 3), 16);
		const g = parseInt(hex.slice(3, 5), 16);
		const b = parseInt(hex.slice(5, 7), 16);

		// Mix with white - 80% toward white for more subtle toolbar color pulse
		const whiteAmount = 0.8;
		const r2 = Math.round(r + (255 - r) * whiteAmount);
		const g2 = Math.round(g + (255 - g) * whiteAmount);
		const b2 = Math.round(b + (255 - b) * whiteAmount);

		return `#${r2.toString(16).padStart(2, '0')}${g2.toString(16).padStart(2, '0')}${b2.toString(16).padStart(2, '0')}`;
	};

	// Create a lightened version of the color
	const lightenedColor = hexToWhitened(displayColor);

	return {
		'--pulse-bg-color-light': lightenedColor, // dynamic lightened color
		'--pulse-bg-color-white': '#ffffff' // white (to maintain opaque toolbar)
	};
}